export default __webpack_public_path__ + "static/media/Social Links.f16f7a74.svg";